module.exports = __webpack_public_path__ + "img/camerastu1.98cf1f52.jpeg";